/**
 * Fragment节点
 *
 */
export const FRAGMENT_NODE = Symbol.for('Fragment');

/**
 * 文本节点
 *
 */
export const TEXT_NODE = Symbol.for('TEXT_ELEMENT');
